import { useEffect, useState } from 'react';

export function useLandingNavigationVisibility() {
  const [hasReachedFeatures, setHasReachedFeatures] = useState(false);
  const [isHorizontalNavigationVisible, setIsHorizontalNavigationVisible] = useState(false);

  useEffect(() => {
    const features = document.getElementById('features');
    const horizontalNavigation = document.getElementById('hero-horizontal-navigation');
    if (!features || !horizontalNavigation) return undefined;

    const featuresObserver = new IntersectionObserver(([entry]) => {
      const viewportBottom = entry.rootBounds?.bottom ?? window.innerHeight;
      setHasReachedFeatures(entry.boundingClientRect.top < viewportBottom * 0.78);
    });
    const horizontalNavigationObserver = new IntersectionObserver(([entry]) => {
      setIsHorizontalNavigationVisible(entry.isIntersecting);
    });

    featuresObserver.observe(features);
    horizontalNavigationObserver.observe(horizontalNavigation);

    return () => {
      featuresObserver.disconnect();
      horizontalNavigationObserver.disconnect();
    };
  }, []);

  return {
    shouldShowSectionNavigation: hasReachedFeatures && !isHorizontalNavigationVisible,
  };
}
